import { render, staticRenderFns } from "./swimVirus.vue?vue&type=template&id=5a948ac3&scoped=true&"
import script from "./swimVirus.vue?vue&type=script&lang=js&"
export * from "./swimVirus.vue?vue&type=script&lang=js&"
import style0 from "./swimVirus.vue?vue&type=style&index=0&id=5a948ac3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a948ac3",
  null
  
)

export default component.exports